import React from 'react'
import { Link } from 'react-router-dom'
const Error = () => {
    return (
        <div className="h-96 flex justify-center items-center bg-formclr flex-col">
           <h1 className="font-extrabold text-blk-txt text-4xl text-center">Error 404</h1>
           <p className="py-2 text-xs font-semibold text-ash">We are sorry, the page you've requested is not available.</p>
           <Link to="/" className="px-5  py-2 mt-2 border-2 transition delay-150 ease-linear border-primary-txt cursor-pointer text-primary-txt hover:bg-primary-txt hover:text-white">Back To Home</Link>
        </div>
    )
}

export default Error
